import { render, staticRenderFns } from "./pie.vue?vue&type=template&id=9025f1f0&"
import script from "./pie.vue?vue&type=script&lang=js&"
export * from "./pie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kasingkhoo/NestJsProjects/ivm_web_ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9025f1f0')) {
      api.createRecord('9025f1f0', component.options)
    } else {
      api.reload('9025f1f0', component.options)
    }
    module.hot.accept("./pie.vue?vue&type=template&id=9025f1f0&", function () {
      api.rerender('9025f1f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/components/pie.vue"
export default component.exports